import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TitleStrategy } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AppComponent } from '@connect/app.component';
import { ContactService } from '@connect/contact/services/contact.service';
import { LookupService } from '@connect/secure/services/lookup.service';
import { ClientService } from '@connect/contact/services/client.service';
import { ConfigModel } from '@connect/shared/models/config.model';
import { BaseHttpClientService } from '@connect/shared/services/base-http-client.service';
import { ToastService } from '@connect/shared/services/toast.service';
import { ConnectTitleStrategyProvider } from '@connect/shared/providers/connect-title-strategy.provider';
import { AppRoutingModule } from '@connect/app-routing.module';

function loadConfig(http: HttpClient, config: ConfigModel): (() => Promise<boolean>) {
    return (): Promise<boolean> => {
        return new Promise<boolean>((resolve: (a: boolean) => void): void => {
            http.get<ConfigModel>('/assets/config.json')
                .subscribe({
                    next: (c: ConfigModel): void => {
                        Object.assign(config, c);
                        resolve(true);
                    },
                    error: e => resolve(false)
                });
        });
    };
}

@NgModule({
    bootstrap: [
        AppComponent
    ],
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ButtonModule,
        BrowserAnimationsModule,
        CommonModule,
        RadioButtonModule,
        FormsModule,
        HttpClientModule,
        ToastModule
    ],
    providers: [
        ContactService,
        LookupService,
        ClientService,
        BaseHttpClientService,
        ConfigModel,
        ToastService,
        MessageService,
        {
            provide: APP_INITIALIZER,
            useFactory: loadConfig,
            deps: [
                HttpClient,
                ConfigModel
            ],
            multi: true
        },
        {
            provide: TitleStrategy,
            useClass: ConnectTitleStrategyProvider
        }
    ]
})
export class AppModule {
}
